import React from "react";
import { PeekBox, PeekStack } from "@piiqtechnologies/ui-components";
import { ChatGpt, Claude, Gemini, Perplexity } from "@piiqtechnologies/svg-icons";
const MODEL_ICONS = {
    Gemini,
    ChatGPT: ChatGpt,
    Claude,
    Perplexity,
};
export const ModelListIcon = ({ modelLabels }) => {
    if (!(modelLabels === null || modelLabels === void 0 ? void 0 : modelLabels.length)) {
        return null;
    }
    const modelsCount = modelLabels.length;
    const overlapOffset = modelsCount >= 4 ? -1 : modelsCount === 3 ? -0.75 : -0.5;
    return (React.createElement(PeekStack, { direction: "row", gap: 0, alignItems: "center" }, modelLabels.map((label, index) => {
        const Icon = MODEL_ICONS[label];
        if (!Icon) {
            return null;
        }
        return (React.createElement(PeekBox, { key: label, sx: {
                width: "24px",
                height: "24px",
                borderRadius: "999px",
                border: "1px solid",
                borderColor: "divider",
                bgcolor: "background.paper",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                ml: index === 0 ? 0 : overlapOffset,
                zIndex: modelLabels.length - index,
            } }, React.createElement(Icon, { width: 14, height: 14 })));
    })));
};
export default ModelListIcon;
